import {AbstractService} from 'services/AbstractService';

const SHOP_URL = '/api/seller/shops';
const DELETE_SHOP_URL = '/api/seller/shops/{0}';
const RESTORE_SHOP_URL = '/api/seller/shops/{0}';

export class ShopSellerService extends AbstractService {
  createShop (payload) {
    return this.client.post(SHOP_URL, payload);
  }

  deleteShop (shopId) {
    return this.client.delete(DELETE_SHOP_URL.format(shopId));
  }

  restoreShop (shopId, payload) {
    return this.client.put(RESTORE_SHOP_URL.format(shopId), payload);
  }

  getShopsCurrentUser () {
    return this.client.get(SHOP_URL);
  }
}
